module.exports = "<svg [ngStyle]=\"style\" [attr.width]=\"width\" [attr.height]=\"height\">\n  <ng-content></ng-content>\n</svg>"